import { usePageTitle } from "./hooks/usePageTitle";

function UsefulReading() {
  usePageTitle('Useful Reading')
  return (
    <div
      id="ts-usefulreading-wrapper"
      className="w-full h-full flex items-center justify-center"
    >
      <div
        id="ts-usefulreading-content"
        className="w-2/3 p-4 h-full flex flex-col items-center"
      >
        <div className="w-full relative flex items-center justify-center text-2xl p-2 border-b border-light-border">
          Useful Reading
        </div>
        <div className="text-normal text-light-text p-2 text-center">
          <span>
            The following are books and papers that users may find beneficial in
            utilizing our software. Please note: TERRASCIENCES does not
            sell,copy, or in any other way duplicate these books and papers. It
            is up to the individual to acquire them.
          </span>
        </div>
        <div className="w-full flex flex-col text-light-text p-2 mt-4 text-left">
          <div className="text-lg border-b border-light-border mb-2">
            Petrophysics and Log Analysis
          </div>
          <ul className="list-disc list-inside space-y-2">
            <li>
              <strong>Fundamentals of Formation Evaluation</strong>, D.P.
              Helander; 1984. OGCI Publications. ISBN 0-930972-02-3.
            </li>
            <li>
              <strong>Log Interpretation Principles/Applications</strong>; 1987.
              Schlumberger Educational Series, Order No. SMP-7017.
            </li>
            <li>
              <strong>Formation Evaluation I and II</strong>; 1990. Treatise of
              Petroleum Geology Reprint Series No. 17, AAPG. ISBN 0-89181-415-9.
            </li>
            <li>
              <strong>Core-Log Integration</strong>, ed. P.K. Harvey and M.A.
              Lovell; 1998. Geological Society Special Publication no. 136. ISBN
              1-86239-0169.
            </li>
            <li>
              <strong>Principles of Mathematical Petrophysics</strong>, John H.
              Doveton; 2014. Oxford University Press. ISBN 978-0-19-997804-5.
            </li>
            <li>
              <strong>Petrophysics — A Practical Guide</strong>, S. Cannon;
              2016. Wiley Blackwell. ISBN 978-1-118-74673-8.
            </li>
          </ul>
        </div>
        <div className="w-full flex flex-col text-light-text p-2 mt-4 text-left">
          <div className="text-lg border-b border-light-border mb-2">
            Geological Use of Wireline Data
          </div>
          <ul className="list-disc list-inside space-y-2">
            <li>
              <strong>Geologic Log Analysis Using Computer Methods</strong>,
              John H Doveton, 1994. AAPG Computer Applications in Geology, No.
              2. ISBN 0-89181-701-8
            </li>
            <li>
              <strong>The Geological Interpretation of Well Logs</strong>, 3rd
              edition, Malcolm Rider & Martin Kennedy, 2011. ISBN
              978-0-9541906-8-2
            </li>
          </ul>
        </div>

        <div className="w-full flex flex-col text-light-text p-2 mt-4 text-left">
          <div className="text-lg border-b border-light-border mb-2">
            Borehole Imaging
          </div>
          <ul className="list-disc list-inside space-y-2">
            <li>
              <strong>Borehole Imaging: Applications and Case Histories</strong>
              , ed M.A. Lovell, G. Williamson and P.K. Harvey, 1999. ISBN
              1-86239-043-6
            </li>
            <li>
              <strong>Using Formation Microscanner Images</strong>, L. Bourke,
              et al., 1989. Schlumberger Technical Review, vol 37, no. 1, pp
              16-40.
            </li>
          </ul>
        </div>
        <div className="w-full flex flex-col text-light-text p-2 mt-4 text-left">
          <div className="text-lg border-b border-light-border mb-2">
            Statistical Analysis of Data
          </div>
          <ul className="list-disc list-inside space-y-2">
            <li>
              <strong>
                Statistics and Data Analysis in Geology - 2nd edition
              </strong>
              , J.C. Davis, 1986. ISBN 0-471-08079-9
            </li>
            <li>
              <strong>Geologic Log Analysis Using Computer Methods</strong>,
              John H Doveton, 1994. AAPG Computer Applications in Geology, No.
              2. ISBN 0-89181-701-8
            </li>
          </ul>
        </div>
        <div className="w-full flex flex-col text-light-text p-2 mt-4 text-left">
          <div className="text-lg border-b border-light-border mb-2">
            Geostatistics - kriging, etc.
          </div>
          <ul className="list-disc list-inside space-y-2">
            <li>
              <strong>
                GSLIB - Geostatistical Software Libray and User's Guide
              </strong>
              , C.V. Deutsch and A.G. Journel, 1992. ISBN 0-19-507392-4
            </li>
            <li>
              <strong>
                Statistics and Data Analysis in Geology - 2nd edition
              </strong>
              , J.C. Davis, 1986. ISBN 0-471-08079-9
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default UsefulReading;
